export default __webpack_public_path__ + "static/1605-7225ba641e5876fe5dbfb79bcb5d8956.gif";